import {get, post} from "@/config/api";


const state = {
};

const getters = {};

const mutations = {};

const actions = {
  GetBrand({}, params) {
    return new Promise((resolve, reject) => {
      get(`brand/detail/${params.id}/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
